import React from 'react';
import { AccordionBodyItem } from 'component/Accordion';
import { CheckboxInput } from 'component/Checkbox';

export const AttackUav = (props) => {
  const hazardType = props.formData.info.hazard_type;

  return (
    <AccordionBodyItem
      accordionSubId="3.10"
      titleUA="Ударні БПЛА, частини ударних БПЛА"
      titleEN="Attack UAV and parts"
      className={props.errors.hazard_type ? 'error' : ''}
      children={(
        <CheckboxInput
          id="attackUav"
          name="attack_uav"
          value="attack_uav"
          checked={hazardType.attack_uav}
          handleInput={props.handleContamination}
          disable="false"
        />
      )}
    />
  );
};
